import React from 'react';
import { object } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import Link from '../Link';
import { QUALTRICS_BASE_URL } from './constants';

export const ShareIdeas = (props) => {
    const { userId, userGuid, country, locale, isMobile } = getContext();

    const parameters = {
        user_id: userId,
        uid: userGuid,
        country,
        locale,
        device: isMobile ? 'mobile' : 'desktop',
        page_name: document.title, // Entrypoint Page Name
        page_url: window.location.href, // Entrypoint Page Url
    };
    const path = `${QUALTRICS_BASE_URL}?${new URLSearchParams(parameters).toString()}`;

    const mixpanelData = {
        eventName: 'Feedback - Entry Point - Click',
        eventData: {
            'Menu Text': 'Share your ideas',
            'Form Name': 'Select members features request',
            'Entry Point': 'Avatar Menu',
        },
    };

    return (
        <Link
            {...props}
            mpData={mixpanelData}
            href={path}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
        >
            {(i18n) => i18n.t('header.share_ideas')}
        </Link>
    );
};

ShareIdeas.propTypes = {
    bigQueryData: object,
};
